import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_STATUTORY_DECLARATION_Mapper extends BaseFormMapper<HOME_TRUST_STATUTORY_DECLARATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_STATUTORY_DECLARATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_STATUTORY_DECLARATION);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_STATUTORY_DECLARATION> {
		return {};
	}
}

const Mappings: HOME_TRUST_STATUTORY_DECLARATION = {
	province: 'Province',
	// "1":"Print",
	of2: 'of2',
	of3: 'of3',
	of_the: 'of the1',
	in_the2: 'in the2',
	in_the: 'in the1',
	of4: 'of4',
	of: 'of1',
	I_We: 'I/We',
	from2: 'From2',
	from1: 'From1',
	thereOf: 'thereof',
	subtitle: 'Title2',
	title: 'Title1',
	owner2: 'Owner2',
	owner1: 'Owner1',
	month: 'month',
	day: 'day',
	year: 'year',
	// "20":"Para5",
	statement: '5',
};

export interface HOME_TRUST_STATUTORY_DECLARATION {
	province: string;
	title: string;
	subtitle: string;
	I_We: string;
	from1: string;
	from2: string;
	of_the: string;
	of: string;
	in_the: string;
	of2: string;
	statement: string;
	of3: string;
	of4: string;
	in_the2: string;
	owner1: string;
	owner2: string;
	day: string;
	month: string;
	year: string;
	thereOf: string;
}
